import { useEffect, useState } from "react";

/** Give up waiting after this; the image may still pop in later. */
const IMAGE_WAIT_MS = 4000;

/** True once `url` loaded, failed or took too long; null = nothing to wait for. */
export function useImageReady(url: string | null): boolean {
  const [readyUrl, setReadyUrl] = useState<string | null>(null);
  useEffect(() => {
    if (url === null) return;
    let done = false;
    const finish = (): void => {
      if (done) return;
      done = true;
      setReadyUrl(url);
    };
    const image = new Image();
    image.onload = finish;
    image.onerror = finish;
    image.src = url;
    const timer = window.setTimeout(finish, IMAGE_WAIT_MS);
    return () => {
      done = true;
      window.clearTimeout(timer);
    };
  }, [url]);
  return url === null || readyUrl === url;
}
